export const serverError = 'Server error! Please contact support!';
